export class CompanyManagementCollections {
  static ModuleName = 'companies-management';

  static Companies = `${CompanyManagementCollections.ModuleName}/companies`;
  static company(orderId: string) {
    return `${CompanyManagementCollections.Companies}/${orderId}`;
  }
}
